import { FC } from "react";

interface IconPlusProps {
  className?: string;
  fill?: string;
}

const IconPlus: FC<IconPlusProps> = ({ className, fill }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.37082 8.73966L0.051517 8.73902L0.0523744 7.4791L7.37082 7.47888L7.37083 0.160428L8.63302 0.160428L8.63281 7.47884L15.9514 7.47861L15.9506 8.74041L8.63277 8.73977L8.63255 16.0588L7.37082 16.0579L7.37082 8.73966Z"
        fill={fill ?? "#292D34"}
      />
    </svg>
  );
};

export default IconPlus;
